import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/ReactQueryWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/[lng]/layout.tsx\",\"import\":\"Poppins\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"700\"],\"subsets\":[\"latin\"]}],\"variableName\":\"poppins\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/phone.scss");
